// src/common/security/api.js
// Cloud Functions çağrıları (prod + emu fallback)

const PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID || "ustmas-panel";
const REGION = process.env.REACT_APP_FUNCTIONS_REGION || "us-central1";
const PROD_BASE = `https://${REGION}-${PROJECT_ID}.cloudfunctions.net`;
const EMU_BASE  = `http://127.0.0.1:5001/${PROJECT_ID}/${REGION}`;

async function fetchJson(fnName, body) {
  const urlProd = `${PROD_BASE}/${fnName}`;
  const urlEmu  = `${EMU_BASE}/${fnName}`;
  const isLocalHost = ["localhost", "127.0.0.1"].includes(window.location.hostname);
  let prodError = null;

  try {
    const r = await fetch(urlProd, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body || {}),
      credentials: "omit",
    });
    if (!r.ok) {
      const text = await r.text().catch(() => "");
      throw new Error(`HTTP ${r.status}${text ? `: ${text}` : ""}`);
    }
    return await r.json();
  } catch (e) {
    prodError = e;
    if (/^HTTP \d+/.test(String(e?.message || e))) {
      throw e;
    }
    if (!isLocalHost) {
      throw new Error(`Cloud Function ulasilamadi: ${fnName}`);
    }

    const r2 = await fetch(urlEmu, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body || {}),
      credentials: "omit",
    }).catch((emuError) => {
      throw new Error(
        `Cloud Function ulasilamadi: ${fnName}. Prod: ${prodError?.message || prodError}. Emu: ${emuError?.message || emuError}`
      );
    });
    if (!r2.ok) throw new Error(`HTTP ${r2.status}`);
    return await r2.json();
  }
}

// ---- Güvenlik ----
export async function securityCheck(payload) {
  return fetchJson("securityCheck", payload);
}
export async function adminListThreats(adminEmail) {
  return fetchJson("adminListThreats", { adminEmail });
}
export async function adminAction(adminEmail, payload) {
  return fetchJson("adminAction", { adminEmail, ...(payload || {}) });
}
export async function reportSuspicious(payload) {
  return securityCheck({ action: "directAccess", ...(payload || {}) });
}

// ---- Login oturumları ----
export async function upsertLoginSession({ email, fingerprint, deviceInfo, deviceType }) {
  return fetchJson("upsertLoginSession", { email, fingerprint, deviceInfo, deviceType });
}
export async function endLoginSession({ sessionId }) {
  return fetchJson("endLoginSession", { sessionId });
}

// ---- Beacon (sayfa kapanırken) için salt URL lazım olduğunda:
export const FUNCTIONS_BASES = {
  PROD_BASE,
  EMU_BASE,
  prod: PROD_BASE,
  emu: EMU_BASE,
};
